(() => {
  const BODY_OPEN_CLASS = 'lm-drawer-open';
  let lockedScrollY = 0;

  const closeDesktopMenus = (scope = document) => {
    scope.querySelectorAll('.section-lm-header details[data-lm-menu][open]').forEach((detail) => {
      detail.removeAttribute('open');
    });
  };

  const lockPageScroll = () => {
    if (document.body.classList.contains(BODY_OPEN_CLASS)) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add(BODY_OPEN_CLASS);
    document.body.classList.add(BODY_OPEN_CLASS);
    document.body.style.top = `-${lockedScrollY}px`;
  };

  const unlockPageScroll = () => {
    if (!document.body.classList.contains(BODY_OPEN_CLASS)) return;
    document.documentElement.classList.remove(BODY_OPEN_CLASS);
    document.body.classList.remove(BODY_OPEN_CLASS);
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  };

  const resetDrawer = (details) => {
    if (!details) return;
    details.querySelectorAll('details[open]').forEach((nested) => nested.removeAttribute('open'));
    details.querySelectorAll('.menu-drawer__navigation, .menu-drawer__submenu, .menu-drawer__navigation-container').forEach((el) => {
      el.scrollTop = 0;
    });
  };

  const closeDrawer = (details, restoreFocus = true) => {
    if (!details) return;
    const summary = details.querySelector(':scope > summary');
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    resetDrawer(details);
    unlockPageScroll();
    if (restoreFocus && summary) summary.focus({ preventScroll: true });
  };

  const initHeader = (root) => {
    if (!root || root.dataset.lmInitialized === 'true') return;
    root.dataset.lmInitialized = 'true';

    const syncDrawerTop = () => {
      const top = Math.max(0, root.getBoundingClientRect().top);
      root.style.setProperty('--lm-drawer-top', `${top}px`);
    };

    const drawerDetails = root.querySelector('.menu-drawer-container');
    if (drawerDetails) {
      const overlay = drawerDetails.querySelector('[data-lm-drawer-overlay]');
      let overlayPointerStart = null;

      if (overlay) {
        overlay.addEventListener('pointerdown', (event) => {
          overlayPointerStart = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            time: performance.now()
          };
        });

        overlay.addEventListener('pointerup', (event) => {
          if (!overlayPointerStart || overlayPointerStart.id !== event.pointerId) return;

          const distance = Math.hypot(
            event.clientX - overlayPointerStart.x,
            event.clientY - overlayPointerStart.y
          );
          const elapsed = performance.now() - overlayPointerStart.time;
          overlayPointerStart = null;

          if (distance <= 10 && elapsed <= 500) {
            event.preventDefault();
            closeDrawer(drawerDetails);
          }
        });

        overlay.addEventListener('pointercancel', () => {
          overlayPointerStart = null;
        });
      }

      drawerDetails.addEventListener('toggle', () => {
        if (drawerDetails.open) {
          syncDrawerTop();
          resetDrawer(drawerDetails);
          lockPageScroll();
          const closeButton = drawerDetails.querySelector('[data-lm-drawer-close]');
          requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
        } else {
          unlockPageScroll();
        }
      });
    }

    const onViewportChange = () => {
      syncDrawerTop();
      if (drawerDetails?.open) {
        drawerDetails.querySelectorAll('.menu-drawer__navigation, .menu-drawer__submenu').forEach((el) => {
          el.scrollTop = Math.min(el.scrollTop, Math.max(0, el.scrollHeight - el.clientHeight));
        });
      }
    };

    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('orientationchange', onViewportChange, { passive: true });
    window.addEventListener('scroll', () => {
      if (drawerDetails && drawerDetails.open) syncDrawerTop();
    }, { passive: true });
    syncDrawerTop();

    root.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-lm-drawer-close]');
      if (closeButton) {
        closeDrawer(closeButton.closest('.menu-drawer-container'));
        return;
      }

      const openedMenu = event.target.closest('details[data-lm-menu]');
      root.querySelectorAll('details[data-lm-menu][open]').forEach((detail) => {
        if (detail !== openedMenu) detail.removeAttribute('open');
      });
    });
  };

  const initAll = () => document.querySelectorAll('.section-lm-header').forEach(initHeader);

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.section-lm-header details[data-lm-menu]')) closeDesktopMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDesktopMenus();
      document.querySelectorAll('.section-lm-header .menu-drawer-container[open]').forEach((details) => {
        closeDrawer(details);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', unlockPageScroll);
  initAll();
})();
